import React from 'react';
import { connect } from 'react-redux';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DraggableItemList from '../components/DraggableItemList';
import { getSortIndex } from '../sortIndex';
import { updateSortIndexes } from '../actions/question';
import { questionsForSectionRaw } from '../reducer';
import {adminCardStyle} from './AdminHomepage';

class QuestionSortOrder extends React.Component {

  state = {
    value: 'monitoring'
  };

  handleChange = (event, index, value) => {
    this.setState({
      value
    });
  }

  handleSave = () => {
    this.props.updateSortIndexes(this.state.value, this.list.getItems());
  }

  render() {
    let { questionsForSection } = this.props;
    const section = this.state.value;
    const questions = questionsForSection[section]
      .sort((a, b) => getSortIndex(section, a.sortIndex) - getSortIndex(section, b.sortIndex))
    return (
      <React.Fragment>
        <Card style={adminCardStyle}>
          <CardHeader
            title="Question Sort Order"
          />
          <CardText>
            Drag and drop questions to change their sort order below. Questions
            that appear in multiple sections can be ordered uniquely within each
            section. <b>Be sure to click save</b> when you want to commit changes for a
            section. Switching to another section without saving will lose any reordering.
          </CardText>
          <CardActions>
          <SelectField
            style={{marginLeft: 10}}
            floatingLabelText="Section"
            value={this.state.value}
            onChange={this.handleChange}
          >
            <MenuItem value="monitoring" primaryText="Data Collection" />
            <MenuItem value="assessment" primaryText="Assessment" />
            <MenuItem value="controlRules" primaryText="Management Measures" />
          </SelectField>
          <RaisedButton onClick={this.handleSave} label="Save" primary style={{position: 'relative', top: -18, left: 10}} />
          </CardActions>
        </Card>

        <Card style={adminCardStyle}>
          <DraggableItemList section={section} items={questions} ref={(list) => this.list = list} />
        </Card>
      </React.Fragment>
    )
  }

}


const mapStateToProps = (state) => {
  return {
    questionsForSection: {
      monitoring: questionsForSectionRaw('monitoring', state.questions, state.options, {}),
      assessment: questionsForSectionRaw('assessment', state.questions, state.options, {}),
      controlRules: questionsForSectionRaw('controlRules', state.questions, state.options, {})
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateSortIndexes: (section, questions) => dispatch(updateSortIndexes(section, questions))
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionSortOrder);
